/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Drop_Files_TitleInputs */



/**
* | output |
* | --- |
* | "Drop files to upload" |
*
* @param {Spaces_Drop_Files_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_drop_files_title = /** @type {((inputs?: Spaces_Drop_Files_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Drop_Files_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateien hier ablegen, um sie hochzuladen")
	return /** @type {LocalizedString} */ ("Drop files to upload")
});